import React from 'react';
import { useTheme } from '@mui/material';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Box, TableSortLabel, Skeleton } from '@mui/material';

const GenericTable = ({
  columns,
  data,
  actions,
  onSort,
  sortConfig,
  renderActions,
  loading,
  rowLoading = () => false, 
}) => {
  const theme = useTheme();

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((column, index) => (
              <TableCell
                key={index}
                sx={{
                  backgroundColor: theme.palette.primary.light_gray,
                  fontWeight: 'bold',
                  padding: '8px',
                  cursor: 'pointer',
                  textAlign: column.headerAlign || 'left',
                }}
              >
                <TableSortLabel
                  active={sortConfig?.key === column?.field}
                  direction={sortConfig?.key === column?.field ? sortConfig.direction : 'asc'}
                  onClick={() => onSort(column?.field)}
                >
                  {column.label}
                </TableSortLabel>
              </TableCell>
            ))}
            {actions && (
              <TableCell
                sx={{ backgroundColor: theme.palette.primary.light_gray, fontWeight: 'bold', padding: '8px' }}
              >
                Actions
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {/* Display global loading skeletons for all rows */}
          {loading ? (
            Array.from({ length: 5 }).map((_, rowIndex) => (
              <TableRow key={rowIndex}>
                {columns.map((_, colIndex) => (
                  <TableCell key={colIndex}>
                    <Skeleton variant="rectangular" height={30} />
                  </TableCell>
                ))}
                {actions && (
                  <TableCell>
                    <Skeleton variant="rectangular" height={30} width={50} />
                  </TableCell>
                )}
              </TableRow>
            ))
          ) : data && data.length > 0 ? (
            data.map((row, rowIndex) => (
              <TableRow
                key={rowIndex}
                sx={{ height: '40px' }}
              >
                {rowLoading(row) ? (
                  // Render skeletons for this specific row
                  <>
                    {columns.map((_, colIndex) => (
                      <TableCell key={colIndex}>
                        <Skeleton variant="rectangular" height={30} />
                      </TableCell>
                    ))}
                    {actions && (
                      <TableCell>
                        <Skeleton variant="rectangular" height={30} width={50} />
                      </TableCell>
                    )}
                  </>
                ) : (
                  // Render actual row data
                  <>
                    {columns.map((column, colIndex) => (
                      <TableCell key={colIndex} sx={{ padding: '6px' }}>
                        {column.render ? column.render(row[column.field], row) : row[column.field]}
                      </TableCell>
                    ))}
                   {actions && (
                  <TableCell sx={{ padding: '6px' }}>
                    <Box display="flex" gap={1}>
                      {actions.map((action, actionIndex) => (
                        <Button
                          key={actionIndex}
                          variant="contained"
                          onClick={() => action.onClick(row)}
                          style={action.style || {}}
                        >
                          {action.icon}
                        </Button>
                      ))}
                    </Box>
                  </TableCell>
                )}

                  </>
                )}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={columns.length + (actions ? 1 : 0)} align="center">
                No records available
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};


export default GenericTable;
